<template>
  <aside
    :aria-label="$t('nav.user_panel')"
    class="user-panel"
  >
    <div
      v-if="loggedIn"
      key="user-panel-signed"
      class="panel panel-default signed-in"
    >
      <UserCard
        :user-id="currentUser.id"
        :hide-bio="true"
      />
      <PostStatusForm />
    </div>
    <AuthForm
      v-else
      key="user-panel"
    />
  </aside>
</template>

<script src="./user_panel.js"></script>

<style lang="scss">
.user-panel {
  .panel {
    background: var(--background);
    backdrop-filter: var(--backdrop-filter);
  }

  .user-info {
    .Avatar {
      width: 5em;
      width: calc(min(5em, 20cqw));
      height: 5em;
      height: calc(min(5em, 20cqw));
    }
  }

  .post-status-form {
    margin: 0.5em;
  }

  .signed-in {
    z-index: 10;
  }
}
</style>
